(function ($) {
    "use strict";

    var self = null,
        SEL_WRAPPER = ".w-control",
        FIELD_STATUS_INPUT_NAME = "CustomerAttributeElementStatus",
        FIELD_STATUS_MANDATORY = "Mandatory";

    ori.addModule("customerAttributes", {
        init: function (options) {
            self.setOptions(options);
        },

        isFieldRequired: function ($input, params, validatorInstance) {
            var name = $input.attr("name").split(".");
            if (name.length < 1)
                return false;
            name[name.length - 1] = FIELD_STATUS_INPUT_NAME;
            return $input.closest(SEL_WRAPPER).find("[name=\"" + name.join(".") + "\"]").val() === FIELD_STATUS_MANDATORY;
        }
    });

    self = ori.customerAttributes;
})(jQuery);
